import ApiClient from "@/api/ApiClient.ts";
import qs from "qs";

const state = {
  messages: [],
};

const mutations = {
  setMessages(state, messages) {
    state.messages = messages;
  },
};

const actions = {
  async getMessages({ commit }, customParams) {
    const params = {
      ...customParams,
    };
    try {
      const api = ApiClient();
      let response = await api.get("messages", { params });
      if (Array.isArray(response.data)) {
        commit("setMessages", response.data);
      } else {
        return response.data;
      }
    } catch (error) {
      console.error("ERROR en getMessages: ", error.message);
    }
  },

  async createMessage(_, payload) {
    const params = {
      ...payload.params,
    };
    const urlFormData = qs.stringify(payload.data);

    try {
      const api = ApiClient();
      await api.post("messages", urlFormData, {
        params,
        headers: { "content-type": "application/x-www-form-urlencoded" },
      });
      return true;
    } catch (error) {
      console.error("ERROR en createMessage: ", error.message);
      return false;
    }
  },
};

const getters = {
  messages(state) {
    return state.messages;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
